const $$splitComponentImporter = () => import('/home/runner/work/inspecttec-frontend-admin/inspecttec-frontend-admin/src/routes/client/groups/$groupId.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { Permissions } from "@/constants/permissions";
import { requirePermission } from "@/lib/auth/permission-guard";
import { UserGroupType } from "@/types/api/user-group";
import { createFileRoute } from "@tanstack/react-router";
import * as z from "zod";
const searchSchema = z.object({
  /** Deep-linkable tab (`?tab=members` / `?tab=inspects` from the groups list). */
  tab: z.enum(["roles", "members", "inspects"]).optional().catch(undefined)
});
export const Route = createFileRoute("/client/groups/$groupId")({
  validateSearch: searchSchema,
  beforeLoad: args => requirePermission(Permissions.Support.ViewClientData, args),
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});
const editGroupSchema = z.object({
  userGroupName: z.string().min(1, "Group name is required"),
  userGroupType: z.nativeEnum(UserGroupType, {
    errorMap: () => ({
      message: "Please select a group type"
    })
  }),
  isActive: z.boolean(),
  description: z.string().optional()
});
type EditGroupFormValues = z.infer<typeof editGroupSchema>;